module.exports = __webpack_public_path__ + "static/media/Zee5.13300577.png";